import React from 'react';

const InspirationIcon = () => (
  <svg className="w-16 h-16 text-jskool-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.07V2M12 22v-2.07M20 12h-2.07M6.07 12H4M17.66 6.34l-1.46 1.46M7.8 16.2l-1.46 1.46M17.66 17.66l-1.46-1.46M7.8 7.8l-1.46-1.46"></path>
  </svg>
);

const InspirationSection: React.FC = () => {
  return (
    <section id="inspiration" className="py-20 bg-white">
      <div className="container mx-auto px-6 text-center flex flex-col items-center">
        <InspirationIcon />
        <h2 className="text-4xl font-heading font-extrabold text-jskool-dark mt-6">Our Inspiration</h2>
        <p className="mt-4 font-heading text-2xl font-bold text-jskool-blue">
          Mahesh Chand Jain & Pinki Jain
        </p>
        <p className="max-w-4xl mx-auto mt-6 text-lg text-jskool-dark/80 leading-relaxed">
          This endeavor is dedicated to our parents, who are the bedrock of who we are today. They masterfully balanced their duties of providing for us and managing a household, all while going the extra mile to give us a modern education. Most importantly, they embedded the core principles of Jainism within us—teaching us the difference between right and wrong, making us conscious of our surroundings, and instilling the timeless values of compassion and integrity that guide us every day.
        </p>
      </div>
    </section>
  );
};

export default InspirationSection;